import { useTranslation } from 'next-i18next';
export var useSectionAudio = function useSectionAudio(_ref) {
  var section = _ref.section;

  var _useTranslation = useTranslation('common'),
      translation = _useTranslation.t;

  var audioFile = section === null || section === void 0 ? void 0 : section.audioFile;
  var audioLabel = {
    deleteTitle: translation('deleteConfirmation'),
    deleteOk: translation('yes'),
    deleteCancel: translation('no')
  };
  return {
    audioFile: audioFile,
    audioLabel: audioLabel
  };
};